<style>
.text-field {
    margin-right: 3%;
    padding-left: 20%;
    width: 50px;
}

.text-field .v-label {
    color: #154985;
    opacity: 1;
}

.text-field input {
    color: #154985;
}

.text-field .v-icon {
    color: green;
}
</style>


<template>
    <v-app-bar app light color="#86B404" dense>
        <img src="./static/clubCO2-logo.svg"
            :style="{ height: '150px', width: '150px', marginLeft: '10px', marginTop: '20px' }" />

        <v-toolbar-title v-if="!isMobile" class="primary-text"><i class="fa fab-transition-move"></i>
            <slot name="app-toolbar-title"></slot>
        </v-toolbar-title>


        <v-text-field ref="searchField" class="text-field" :loading="loading" clearable density="compact" variant="solo"
            placeholder="Rechercher..." append-inner-icon="mdi-magnify" append-inner-iconc single-line hide-details
            @click:append-inner="handleEnter" @keyup.enter="handleEnter" @click:clear="() => {this.$refs.searchField.value = ''; handleInput();}">

        </v-text-field>



    </v-app-bar>
</template>

<script>
import { isMobileOnly } from "mobile-device-detect";
import Sidebar from "../../components/common/Sidebar";

export default {
    name: 'app-bar',
    components: { Sidebar },
    data() {
        return {
            isMobile: isMobileOnly,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        handleEnter() {
            this.$emit('TotalSearch', this.$refs.searchField.value);
        },
        handleInput() {
            console.log(this.$refs.searchField.value);
            if (!this.$refs.searchField.value) {
                this.handleEnter();
            }
        }
    }

}
</script>
